import api from './axios';

// Kelime kontrolü
export const checkWord = async (word) => {
    try {
        const response = await api.post("api/v1/Games/dictionary/check", { word });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Kelime kontrolü yapılamadı!" };
    }
};

// Sözlük verisini Redis'e gönder
export const syncDictionaryToRedis = async () => {
    try {
        const response = await api.post("api/v1/Games/data-to-redis-dictionary");
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Redis senkronizasyonu başarısız!" };
    }
};
